import React from 'react';

const AlertBadge = ({ className, status = "medium" }) => {
  const getBadgeConfig = () => {
    switch (status) {
      case "high":
        return {
          backgroundColor: "#000000",
          textColor: "#ffffff",
          text: "!!"
        };
      case "out-of-range":
        return {
          backgroundColor: "#000000",
          textColor: "#ffffff",
          text: "OUT OF RANGE"
        };
      case "medium":
      default:
        return {
          backgroundColor: "#000000",
          textColor: "#f5c10d",
          text: "!"
        };
    }
  };

  const config = getBadgeConfig();

  return (
    <div 
      className={className}
      style={{
        position: 'absolute',
        backgroundColor: config.backgroundColor,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        right: '-8px',
        borderRadius: status === "out-of-range" ? '24px' : '50%',
        boxShadow: '0px 1px 2px 0px rgba(0,0,0,0.3), 0px 2px 6px 2px rgba(0,0,0,0.15)',
        top: '-8px',
        width: status === "out-of-range" ? 'auto' : '24px',
        height: '24px',
        padding: status === "out-of-range" ? '0 8px' : '0'
      }}
    >
      <p 
        style={{
          fontFamily: status === "out-of-range" ? 'Roboto, sans-serif' : 'Roboto, sans-serif',
          fontWeight: status === "out-of-range" ? 700 : 900,
          lineHeight: '16px',
          fontSize: status === "out-of-range" ? '10px' : '16px',
          color: config.textColor,
          textAlign: 'center',
          letterSpacing: status === "out-of-range" ? '0.5px' : '0.8px',
          textTransform: 'uppercase',
          margin: 0,
          flexShrink: 0,
          fontVariationSettings: "'wdth' 100"
        }}
      >
        {config.text}
      </p>
    </div>
  );
};

export default AlertBadge;
